<template>
    <b-collapse :id="`collapse_${advert.advert}`" class="row archive-block-details">
        <b-col cols="12" sm="4">
            <h2>&euro; {{advert.details.rent}} p/m</h2>
            <p>
                Servicekosten: <br/>&euro; {{advert.details.servicecosts}} p/m
                <br/>
                Bruto huur: <br/>&euro; {{advert.details.grossrent}} p/m
            </p>
        </b-col>
        <b-col cols="12" sm="8">
            <b-row v-if="advert.type !== 'project'">
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-road"></i>
                    <strong>Straat</strong>
                </b-col>
                <b-col cols="6" sm="8">
                    {{advert.address.street}}
                </b-col>
            </b-row>
            <b-row v-if="advert.type !== 'project'">
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-home"></i>
                    <strong>Postcode</strong>
                </b-col>
                <b-col cols="6" sm="3">
                    {{advert.address.zipcode}}
                </b-col>
                <b-col cols="6" sm="3">
                    <i class="fad fax fa-list-ol"></i>
                    Huisnr
                </b-col>
                <b-col cols="6" sm="2">
                    {{advert.address.number}}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-map-marker"></i>
                    <strong>Woonplaats</strong>
                </b-col>
                <b-col cols="6" sm="8">
                    {{advert.address.city}}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-shield"></i>
                    <strong>Woningtype</strong>
                </b-col>
                <b-col cols="6" sm="8">
                    {{advert.details.type}}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-square"></i>
                    <strong>Oppervlakte</strong>
                </b-col>
                <b-col cols="6" sm="8">
                    {{advert.details.surface}} m<sup>2</sup>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" sm="4">
                    <i class="fad fax fa-bed"></i>
                    <strong>Slaapkamers</strong>
                </b-col>
                <b-col cols="6" sm="8">
                    {{advert.details.bedrooms}}
                </b-col>
            </b-row>
        </b-col>
    </b-collapse>
</template>

<script>
    export default {
        props: {
            advert: {}
        },
        name: 'HouseDetail'
    }
</script>